import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IMenuSetsResponseBody } from './types';

export const getMenuSets = async (
  limit: number = 50,
  afterId?: string,
  search?: string,
  rangeIds?: string[],
): Promise<IMenuSetsResponseBody> => {
  try {
    const url = new URL(`${API_URL}/menus/menu-sets?limit=${limit}`);
    if (afterId) {
      url.searchParams.append('after_id', afterId);
    }
    if (search) {
      url.searchParams.append('search', search);
    }
    if (rangeIds && rangeIds.length > 0) {
      url.searchParams.append('ranges', rangeIds.join(','));
    }
    const res = await fetch(url.href);

    if (!res.ok) throw new Error(res.statusText);

    return await res.json();
  } catch (e) {
    throw e instanceof Error ? e : new Error(String(e));
  }
};
